import { useQuery } from '@tanstack/react-query';
import service from '../service';

export type UsePaymentSourcesOptions = {
  fishId?: string;
  restaurantGuid?: string;
  enabled?: boolean;
};

/**
 * Wallets and saved cards a Fish may pay with, labelled by owner (own or primary's). Wallets load
 * without a Toast restaurant; cards are listed only when `restaurantGuid` is set.
 */
export function usePaymentSources({
  fishId,
  restaurantGuid,
  enabled = true,
}: UsePaymentSourcesOptions = {}) {
  const query = useQuery({
    queryKey: ['paymentSources', fishId, restaurantGuid ?? null],
    enabled: Boolean(enabled && fishId),
    queryFn: () => {
      if (!fishId) {
        throw new Error('fishId is required');
      }
      return service.getPaymentSources(fishId, restaurantGuid);
    },
    retry: 0,
    refetchOnWindowFocus: false,
  });

  return {
    paymentSources: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
